import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ApiService from "../../../../services/ApiService";
import boxStyles from "../../../../styles/boxStyles";

const HeaderTransportasi = ({ inputFields, setInputFields }) => {
  const [dataRegion, setDataRegion] = useState([]);
  const [region, setRegion] = useState("");
  const [dataUnit, setDataUnit] = useState([]);
  const [unit, setUnit] = useState("");
  const [dataLokasi, setDataLokasi] = useState([]);
  const [lokasi, setLokasi] = useState("");
  const [tanggalKejadian, setTanggalKejadian] = useState("");
  const [waktuKejadian, setWaktuKejadian] = useState("");
  const [tanggalLaporan, setTanggalLaporan] = useState(new Date());

  useEffect(() => {
    getDataRegion();
    getDataUnit();
    getDataLokasi();
    setTanggalLaporan(new Date().toISOString().substring(0, 10));
  }, []);

  const getDataUnit = () => {
    ApiService.getMsUnit().then((res) => {
      var result = res.data.payload;
      setDataUnit(result);
    });
  };
  const getDataRegion = () => {
    ApiService.getMsRegional().then((res) => {
      var result = res.data.payload;
      setDataRegion(result);
    });
  };
  const getDataLokasi = () => {
    ApiService.getMsLokasi().then((res) => {
      var result = res.data.payload;
      setDataLokasi(result);
    });
  };

  const handleUnit = (e) => {
    setUnit(e.target.value);
    setInputFields({ ...inputFields, idUnitBisnis: e.target.value });
  };
  const handleRegion = (e) => {
    setRegion(e.target.value);
    setInputFields({ ...inputFields, idRegional: e.target.value });
  };
  const handleLokasi = (e) => {
    setLokasi(e.target.value);
    setInputFields({ ...inputFields, idLokasi: e.target.value });
  };

  return (
    <div>
      <Box component="div" sx={boxStyles}>
        <Grid container spacing={3}>
          <Grid item xl={6} lg={6} sm={6} xs={12}>
            <Stack spacing={2}>
              <TextField
                name="nomorLkp"
                label="Nomor LKP"
                variant="standard"
                fullWidth
                disabled
                onChange={(e) => setInputFields({ ...inputFields, e })}
              />
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Unit Bisnis
                </InputLabel>
                <Select
                  value={unit}
                  onChange={handleUnit}
                  label="Unit Bisnis"
                  required
                >
                  {dataUnit.map((data) => (
                    <MenuItem id={data.id} key={data.id} value={data.id}>
                      {data.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel>Regional/Anak Perusahaan</InputLabel>
                <Select
                  value={region}
                  onChange={handleRegion}
                  label="Regional/Anak Perusahaan"
                >
                  {dataRegion.map((data) => (
                    <MenuItem id={data.id} key={data.id} value={data.id}>
                      {data.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel>Lokasi</InputLabel>
                <Select value={lokasi} onChange={handleLokasi} label="Lokasi">
                  {dataLokasi.map((data) => (
                    <MenuItem id={data.id} key={data.id} value={data.id}>
                      {data.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          </Grid>
          <Grid item xl={6} lg={6} sm={6} xs={12}>
            <Stack spacing={3}>
              <TextField
                name="tglKejadian"
                label="Tanggal Kejadian"
                variant="standard"
                fullWidth
                type="date"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                  // max: new Date(),
                }}
                value={tanggalKejadian}
                onChange={(e) => {
                  // Validasi lebih kecil sama dengan hari ini
                  // Tidak boleh lebih kecil daripada tgl laporan
                  setTanggalKejadian(e.target.value);
                  setInputFields({
                    ...inputFields,
                    tglKejadian: e.target.value,
                  });
                }}
              />
              <TextField
                name="waktuKejadian"
                label="Waktu Kejadian"
                variant="standard"
                fullWidth
                type="time"
                InputLabelProps={{ shrink: true }}
                value={waktuKejadian}
                onChange={(e) => {
                  setWaktuKejadian(e.target.value);
                  setInputFields({
                    ...inputFields,
                    waktuKejadian: e.target.value,
                  });
                }}
              />
              <TextField
                name="tglLaporan"
                label="Tanggal Laporan"
                variant="standard"
                fullWidth
                type="date"
                InputLabelProps={{ shrink: true }}
                value={tanggalLaporan}
                onChange={(e) => setTanggalLaporan(e.target.value)}
                disabled
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default HeaderTransportasi;
